export default __webpack_public_path__ + "static/media/activity.d17e0824.svg";